import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const LensesPerBox = ({ className  })=>{
    const { getLabel  } = useIntl();
    const { state  } = useCLEcommContext();
    const { lensesPerBox  } = state.configurations;
    const labels = React.useMemo(()=>({
            perBox: getLabel('products.perBox'),
            unit: lensesPerBox === 1 ? getLabel('products.unit.contactLens') : getLabel('products.unit.contactLenses')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: className,
        "data-t": "product-detail-unit-info"
    }, `${lensesPerBox} ${labels.unit} ${labels.perBox}`);
};

export { LensesPerBox };
//# sourceMappingURL=LensesPerBox.js.map
